



































import Vue from "vue";
import Div100vh from "@/components/layout/Div100vh.vue";
import { elementRect, viewportRect, documentRect } from "@/js/util/DOM";
import { Rectangle, create as createRect } from "@/js/geom/Rectangle";

interface Data {
  win: Rectangle;
  doc: Rectangle;
  el: Rectangle;
}

export default Vue.extend({
  components: {
    Div100vh
  },
  data(): Data {
    return {
      win: createRect(),
      doc: createRect(),
      el: createRect()
    };
  },
  mounted() {
    const scroller = () => {
      this.win = viewportRect(window);
      this.doc = documentRect(window);
      this.el = elementRect(this.$el as HTMLElement);
    };
    window.addEventListener("scroll", () => scroller());
    scroller();
  }
});
